module.exports = __webpack_public_path__ + "static/media/20200523-161731-013.158aa886.png";